import { httpJson } from "./client";

function isTransientNetworkError(error) {
  const message = String(error?.message || "");
  return (
    error instanceof TypeError ||
    /failed to fetch|networkerror|network request failed|load failed/i.test(message)
  );
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function listCrmJobs() {
  const data = await httpJson("/crm/jobs", { method: "GET" });
  return Array.isArray(data?.jobs) ? data.jobs : [];
}

export async function extractCrmIntake(payload, { retryDelays = [400, 1200] } = {}) {
  const request = () =>
    httpJson("/crm/intake/extract", {
      method: "POST",
      body: payload || {},
    });

  for (let attempt = 0; ; attempt += 1) {
    try {
      return await request();
    } catch (error) {
      if (!isTransientNetworkError(error) || attempt >= retryDelays.length) {
        throw error;
      }
      await wait(retryDelays[attempt]);
    }
  }
}

export async function extractCrmIntakeFile(file) {
  const form = new FormData();
  form.append("file", file);
  return await httpJson("/crm/intake/extract-file", {
    method: "POST",
    body: form,
  });
}

export async function getCrmJobSummary(jobId) {
  const id = String(jobId || "").trim();
  if (!id) throw new Error("jobId is required");
  return await httpJson(`/crm/jobs/${encodeURIComponent(id)}/summary`, { method: "GET" });
}

export async function listCrmContacts(jobId) {
  const id = String(jobId || "").trim();
  if (!id) throw new Error("jobId is required");
  const data = await httpJson(`/crm/jobs/${encodeURIComponent(id)}/contacts`, { method: "GET" });
  return Array.isArray(data?.contacts) ? data.contacts : [];
}

export async function createCrmContact(jobId, payload) {
  const id = String(jobId || "").trim();
  if (!id) throw new Error("jobId is required");
  return await httpJson(`/crm/jobs/${encodeURIComponent(id)}/contacts`, {
    method: "POST",
    body: payload || {},
  });
}

export async function patchCrmContact(contactId, payload) {
  const id = String(contactId || "").trim();
  if (!id) throw new Error("contactId is required");
  return await httpJson(`/crm/contacts/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: payload || {},
  });
}

export async function listCrmActivities(jobId) {
  const id = String(jobId || "").trim();
  if (!id) throw new Error("jobId is required");
  const data = await httpJson(`/crm/jobs/${encodeURIComponent(id)}/activities`, { method: "GET" });
  return Array.isArray(data?.activities) ? data.activities : [];
}

export async function createCrmActivity(jobId, payload) {
  const id = String(jobId || "").trim();
  if (!id) throw new Error("jobId is required");
  return await httpJson(`/crm/jobs/${encodeURIComponent(id)}/activities`, {
    method: "POST",
    body: payload || {},
  });
}

export async function patchCrmActivity(activityId, payload) {
  const id = String(activityId || "").trim();
  if (!id) throw new Error("activityId is required");
  return await httpJson(`/crm/activities/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: payload || {},
  });
}
